module.exports = __webpack_public_path__ + "slang_icon.png?0f210cae219f9fc73f91a6be50170c45";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/slang_icon.png
// module id = 57
// module chunks = 0